import { useApolloClient } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { GET_PRODUCT_SOLD_DISPLAYS } from "graphql/product/query";
import { UPDATE_PRODUCT_EXTRA_SOLD_COUNT, UPDATE_PRODUCT_SOLD_DISPLAY_MODE } from "graphql/product/mutation";

export const useProductSoldDisplay = ({ productId, productCode, enabled }) => {
  const client = useApolloClient();
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const generation = useRef(null);

  useEffect(() => {
    const request = { active: true };
    generation.current = request;
    setState({ data: null, loading: !!enabled, error: null });
    if (enabled && productCode) {
      client
        .query({
          query: GET_PRODUCT_SOLD_DISPLAYS,
          variables: { product_codes: [productCode] },
          fetchPolicy: "no-cache",
          errorPolicy: "none",
        })
        .then(({ data }) => {
          if (!request.active || request !== generation.current) return;
          const item = data.productSoldDisplays.find((p) => p.product_code === productCode);
          setState({
            data: item || {
              product_id: productId,
              product_code: productCode,
              actual_sold_count: 0,
              extra_sold_count: 0,
              display_mode: "hidden",
            },
            loading: false,
            error: null,
          });
        })
        .catch((error) => {
          if (request.active && request === generation.current) setState({ data: null, loading: false, error });
        });
    }
    return () => {
      request.active = false;
    };
  }, [client, productId, productCode, enabled]);

  const save = async (mutation, field, value) => {
    const request = generation.current;
    const { data } = await client.mutate({
      mutation,
      variables: { product_id: productId, [field]: value },
      errorPolicy: "none",
    });
    const item =
      data[
        mutation === UPDATE_PRODUCT_SOLD_DISPLAY_MODE ? "updateProductSoldDisplayMode" : "updateProductExtraSoldCount"
      ];
    if (request.active && request === generation.current && item.product_id === productId)
      setState({ data: item, loading: false, error: null });
    return item;
  };

  return {
    ...state,
    updateDisplayMode: (mode) => save(UPDATE_PRODUCT_SOLD_DISPLAY_MODE, "display_mode", mode),
    updateExtraSoldCount: (input) => save(UPDATE_PRODUCT_EXTRA_SOLD_COUNT, "extra_sold_count", Number(input)),
  };
};
